import styled from "styled-components";

import { FlexBox, Heading } from "@braze/beacon-core";
import { getColor, getSpacing } from "@braze/beacon-styling";

export const LogoContainer = styled(FlexBox)`
  gap: ${getSpacing("xl")};
  align-items: center;
  margin-bottom: 60px;
  margin-top: 50px;
`;

export const StyledFlex = styled(FlexBox)`
  flex-direction: column;
  max-width: calc(624px - ${getSpacing("xxl")});
  padding-right: ${getSpacing("xxxl")};
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: ${getSpacing("xxl")};
  margin-top: ${getSpacing("xxl")};
  margin-right: 60px;
  color: ${getColor("gray", 0)};
  font-size: clamp(12px, 2.75vw, 48px);
  line-height: clamp(1.3em, 3vw, 1em);
`;

export const StyledListItemContainer = styled(FlexBox)`
  gap: 50px;
`;

export const StyledLogo = styled.img`
  height: 53px;
  width: 113px;
`;
